import { safeJSON } from '../../util/AppData/safeJSON';
const debug = process.env.REACT_APP_DEBUG && false;
const get = (navSection, attributeKey) => {
    const sectionStr = localStorage.getItem(navSection);
    const objectAtSection = safeJSON.parse(sectionStr);
    debug && console.log(`got section ${navSection}, attributeKey ${String(attributeKey)} as`, objectAtSection);
    return objectAtSection && objectAtSection[attributeKey];
};
const set = (navSection, attributeKey, value) => {
    const existingSectionStr = localStorage.getItem(navSection);
    const objectAtSection = safeJSON.parse(existingSectionStr);
    const newValue = { ...objectAtSection, [attributeKey]: value };
    const sectionStr = JSON.stringify(newValue);
    debug && console.log(`save section ${navSection}, attributeKey ${String(attributeKey)}, value ${newValue} as`, newValue);
    try {
        localStorage.setItem(navSection, sectionStr);
    }
    catch (e) {
        console.warn('Could not store item to local storage, quota likely exceeded', e);
    }
};
export const AppLocalStorage = {
    get,
    set,
};
